/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const TimesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M10.4099 8.99921L16.7099 2.70921C16.8982 2.52091 17.004 2.26551 17.004 1.99921C17.004 1.73291 16.8982 1.47751 16.7099 1.28921C16.5216 1.10091 16.2662 0.995117 15.9999 0.995117C15.7336 0.995117 15.4782 1.10091 15.2899 1.28921L8.99994 7.58921L2.70994 1.28921C2.52164 1.10091 2.26624 0.995117 1.99994 0.995117C1.73364 0.995117 1.47824 1.10091 1.28994 1.28921C1.10164 1.47751 0.995847 1.73291 0.995847 1.99921C0.995847 2.26551 1.10164 2.52091 1.28994 2.70921L7.58994 8.99921L1.28994 15.2892C1.19621 15.3822 1.12182 15.4928 1.07105 15.6146C1.02028 15.7365 0.994141 15.8672 0.994141 15.9992C0.994141 16.1312 1.02028 16.2619 1.07105 16.3838C1.12182 16.5056 1.19621 16.6162 1.28994 16.7092C1.3829 16.8029 1.4935 16.8773 1.61536 16.9281C1.73722 16.9789 1.86793 17.005 1.99994 17.005C2.13195 17.005 2.26266 16.9789 2.38452 16.9281C2.50638 16.8773 2.61698 16.8029 2.70994 16.7092L8.99994 10.4092L15.2899 16.7092C15.3829 16.8029 15.4935 16.8773 15.6154 16.9281C15.7372 16.9789 15.8679 17.005 15.9999 17.005C16.132 17.005 16.2627 16.9789 16.3845 16.9281C16.5064 16.8773 16.617 16.8029 16.7099 16.7092C16.8037 16.6162 16.8781 16.5056 16.9288 16.3838C16.9796 16.2619 17.0057 16.1312 17.0057 15.9992C17.0057 15.8672 16.9796 15.7365 16.9288 15.6146C16.8781 15.4928 16.8037 15.3822 16.7099 15.2892L10.4099 8.99921Z"
        fill="#F6FAFD"
      />
    </svg>
  )
}
